'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.Common.GridStatus', dependencies).controller('GridStatusController', require('./controllers/GridStatusController')).directive('rmGridStatus', require('./directives/GridStatusDirective')).factory('GridStatusCustomRenderersFactory', require('./factories/GridStatusCustomRenderersFactory'));